module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Adicionar Ação")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.name),
      expression: "newAction.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newAction.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.description),
      expression: "newAction.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newAction.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.type),
      expression: "newAction.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Tipo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAction, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change()
      }]
    }
  }, _vm._l((_vm.fieldTypes), function(fieldType) {
    return _c('option', {
      domProps: {
        "value": fieldType
      }
    }, [_vm._v(_vm._s(fieldType))])
  }), 0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.value),
      expression: "newAction.value"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "link",
      "placeholder": "URL do link",
      "type": "url"
    },
    domProps: {
      "value": (_vm.newAction.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebae5a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepActionDetail.vue
// module id = 1381
// module chunks = 1